import React, { createContext, useState, useEffect } from 'react';
import { API_URL } from '../config';

export const GlobalDiscountContext = createContext();

export const GlobalDiscountProvider = ({ children }) => {
  const [globalDiscount, setGlobalDiscount] = useState({
    enabled: false,
    percentage: 0,
    name: 'Sale',
    startDate: null,
    endDate: null
  });

  useEffect(() => {
    const fetchGlobalDiscount = async () => {
      try {
        const response = await fetch(`${API_URL}/site-settings`);
        const data = await response.json();

        if (data.globalDiscount) {
          setGlobalDiscount(data.globalDiscount);
        }
      } catch (error) {
        console.error('Error fetching global discount:', error);
      }
    };

    fetchGlobalDiscount();

    // Refresh discount every 5 minutes to catch admin updates
    const interval = setInterval(fetchGlobalDiscount, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // Helper function to calculate discounted price
  const applyDiscount = (price) => {
    if (!globalDiscount.enabled || globalDiscount.percentage === 0) {
      return {
        originalPrice: price,
        discountedPrice: price,
        discountPercentage: 0,
        savings: 0,
        hasDiscount: false
      };
    }

    const savings = price * (globalDiscount.percentage / 100);
    const discountedPrice = price - savings;

    return {
      originalPrice: price,
      discountedPrice: Math.round(discountedPrice * 100) / 100,
      discountPercentage: globalDiscount.percentage,
      savings: Math.round(savings * 100) / 100,
      hasDiscount: true,
      name: globalDiscount.name
    };
  };

  return (
    <GlobalDiscountContext.Provider value={{ globalDiscount, applyDiscount }}>
      {children}
    </GlobalDiscountContext.Provider>
  );
};
